import { Flex, useColorModeValue as colorValue } from '@chakra-ui/react'
import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import {
    Dashboard, Profile, Form, Queue, Manual, FormAgreement,
    NotFound, FormStep2, FormStep3, FormFinal, FormEdit, AdminDashboard, AdminForms, 
    AdminNewForms, AdminUsers, AdminAddUser, AdminEmail, Regulations,
    AdminContract,ResidentDashboard,
} from '../../pages'
import { useUserContext } from '../../context/userContext'

// all router for authenticated user
const routes = [
    // super admin , admin
    {
        path: "/dashboard",
        roles: [1, 2],
        component: AdminDashboard
    },
    {
        path: "/newforms",
        roles: [1, 2],
        component: AdminNewForms
    },
    {
        path: "/forms",
        roles: [1, 2],
        component: AdminForms
    },
    {
        path: "/email",
        roles: [1, 2],
        component: AdminEmail
    },
    {
        path: "/contract",
        roles: [1, 2],
        component: AdminContract
    },
    {
        path: "/users",
        roles: [1],
        component: AdminUsers
    },
    {
        path: "/adduser",
        roles: [1],
        component: AdminAddUser
    },
    // resident : ผู้พักอาศัย
    {
        path: "/dashboard",
        roles: [4],
        component: ResidentDashboard
    },
    {
        path: "/history",
        roles: [4],
        component: Dashboard
    },

    // user
    {
        path: "/dashboard",
        roles: [5],
        component: Dashboard
    },
    {
        path: "/formagree",
        roles: [5],
        component: FormAgreement
    },
    {
        path: "/form",
        exact: true,
        roles: [5],
        component: Form
    },
    {
        path: "/form/:fid/edit",
        roles: [5],
        component: FormEdit
    },
    {
        path: "/form/:fid/step2",
        roles: [5],
        component: FormStep2
    },
    {
        path: "/form/:fid/step3",
        roles: [5],
        component: FormStep3
    },
    {
        path: "/form/:fid/final",
        roles: [5],
        component: FormFinal
    },
    // all authen user
    {
        path: "/queue",
        roles: [1, 2, 3, 4, 5],
        component: Queue,
    },
    {
        path: "/profile",
        roles: [1, 2, 3, 4, 5],
        component: Profile,
    },
    {
        path: "/manual",
        roles: [1, 2, 3, 4, 5],
        component: Manual,
    },
    {
        path: "/regulations",
        roles: [1, 2, 3, 4, 5],
        component: Regulations,
    }
]

const AuthorizedRoute = ({ component: Component, ...rest }) => {
    const { userData } = useUserContext()
    return (
        <Route
            {...rest}
            render={({ location }) => userData.authorized ? (<Component />)
                : (
                    <Redirect to={{
                        pathname: "/",
                        state: { from: location }
                    }} />
                )}
        />
    )
}

const AuthorizedSwitch = () => {
    const { userData } = useUserContext()
    const authenRoutes = routes.filter(r => r.roles.includes(userData.role_id))

    return (
        <Switch>
            <Redirect exact from="/" to="/dashboard" />
            {
                authenRoutes.map((r, index) => <AuthorizedRoute exact={r.exact} path={r.path} component={r.component} key={`route_${index}`} />)
            }
            <Route component={NotFound} />
        </Switch>
    )
}

const AuthorizedContent = ({...rest}) => {
    return (
        <Flex w="full" bgColor={colorValue("gray.100", "gray.600")} {...rest}>
            <AuthorizedSwitch />
        </Flex>
    )
}

export default AuthorizedContent
